export default "__VITE_ASSET__Yq4Y5OPv__"